import {useTranslation} from 'lib/i18n';
import {useMemo} from 'react';

export default function useNumberOfUnitsOptions() {
  const {t} = useTranslation();

  return useMemo(() => t('inputsTranslation:property taxes.number of units options', {returnObjects: true}), [t]);
}
